const HeaderMenu = () => {
  const page = document.querySelector(".page");
  const menuOpener = document.querySelector(".header__burger-opener");
  const menuClosers = [...document.querySelectorAll(".header__burger-closer")];
  const headerHolder = document.querySelector(".header__holder");
  
  const inputOpener = document.querySelector(".search-input__opener");
  const headerSearchInput = headerHolder.querySelector(".search-input__wrapper");
  const inputCloser = document.querySelector(".search-full-btn");

  if (menuOpener) {
    menuOpener.addEventListener("click", () => {
      headerHolder.classList.add("opened");
      page.classList.add("overlay");
    })
  }

  if (menuClosers.length > 0) {
    menuClosers.forEach((menuCloser) => {
      menuCloser.addEventListener("click", () => {
        headerHolder.classList.remove("opened");
        page.classList.remove("overlay");
      })
    });
  }

  if (inputOpener) {
    inputOpener.addEventListener("click", () => {
      headerSearchInput.classList.add("opened");
      page.classList.add("overlay");
    })
  }

  if (inputCloser) {
    inputCloser.addEventListener("click", () => {
      headerSearchInput.classList.remove("opened");
      page.classList.remove("overlay");
    })
  }
}


export default HeaderMenu;